import type {
  movementList,
  operationStatus,
  operationType,
  contributionList,
  forexList,
  lastMovement,
} from './type'
import myMovementsData from '../../data/myMovementsData.json'
import MyContributionsData from '../../data/myMovementsContributionsData.json'
import operationTypeMovementData from '../../data/operationTypeMovementData.json'
import operationStatusMovementData from '../../data/operationStatusMovementData.json'
import myMovementsForexData from '../../data/myMovementsForexData.json'
import myLastMovement from '../../data/myLastMovement.json'

export class movementService {
  async myMovementList(
    clientId: number,
    page: number,
    size: number,
    filters: any,
  ): Promise<{ data: movementList[]; total: number }> {
    if (!clientId) {
      throw new Error('clientId is required.')
    }
    let filteredMovement = myMovementsData.data.filter((transfer) => transfer.clientId === clientId)
    if (filters) {
      if (filters.thirdPartySearch) {
        const searchLower = filters.thirdPartySearch.toLowerCase()
        filteredMovement = filteredMovement.filter((item) =>
          item.beneficiary.toLowerCase().includes(searchLower),
        )
      }

      if (filters.operationtype) {
        console.log(filters.operationtype)
        filteredMovement = filteredMovement.filter(
          (item) => item.movement.id === filters.operationtype,
        )
      }

      if (filters.operationStatus) {
        filteredMovement = filteredMovement.filter(
          (item) => item.status.id === filters.operationStatus,
        )
      }

      if (filters.date && filters.date.length === 2) {
        const [startRaw, endRaw] = filters.date.map((d: string) => new Date(d))

        // Normalizar las fechas al inicio del día
        const start = new Date(startRaw.setHours(0, 0, 0, 0))
        const end = new Date(endRaw.setHours(23, 59, 59, 999)) // incluir todo el día

        filteredMovement = filteredMovement.filter((item) => {
          const [dd, mm, yyyy] = item.date.split('/')
          const itemDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`)
          return itemDate >= start && itemDate <= end
        })
      }
    }

    const total = filteredMovement.length
    const start = page * size
    const end = start + size
    const paginatedData = filteredMovement.slice(start, end)
    return {
      data: paginatedData,
      total,
    }
  }

  async myContributionsList(
    clientId: number,
    page: number,
    size: number,
    filters: any,
  ): Promise<{ data: contributionList[]; total: number }> {
    if (!clientId) {
      throw new Error('Both clientId and operationStatus are required.')
    }
    let filteredMovement = MyContributionsData.data.filter(
      (transfer) => transfer.clientId === clientId,
    )
    if (filters) {
      if (filters.operationtype) {
        console.log(filters.operationtype)
        filteredMovement = filteredMovement.filter(
          (item) => item.movement.id === filters.operationtype,
        )
      }

      if (filters.date && filters.date.length === 2) {
        const [startRaw, endRaw] = filters.date.map((d: string) => new Date(d))

        const start = new Date(startRaw.setHours(0, 0, 0, 0))
        const end = new Date(endRaw.setHours(23, 59, 59, 999))

        filteredMovement = filteredMovement.filter((item) => {
          const [dd, mm, yyyy] = item.date.split('/')
          const itemDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`)
          return itemDate >= start && itemDate <= end
        })
      }
    }

    const total = filteredMovement.length
    const start = page * size
    const end = start + size
    const paginatedData = filteredMovement.slice(start, end)
    return {
      data: paginatedData,
      total,
    }
  }

  async myForexList(
    clientId: number,
    page: number,
    size: number,
    filters: any,
  ): Promise<{ data: forexList[]; total: number }> {
    if (!clientId) {
      throw new Error('Both clientId and operationStatus are required.')
    }
    let filteredMovement = myMovementsForexData.data.filter(
      (transfer) => transfer.clientId === clientId,
    )
    if (filters) {
      if (filters.operationtype) {
        console.log(filters.operationtype)
        filteredMovement = filteredMovement.filter(
          (item) => item.movement.id === filters.operationtype,
        )
      }

      if (filters.date && filters.date.length === 2) {
        const [startRaw, endRaw] = filters.date.map((d: string) => new Date(d))

        const start = new Date(startRaw.setHours(0, 0, 0, 0))
        const end = new Date(endRaw.setHours(23, 59, 59, 999))

        filteredMovement = filteredMovement.filter((item) => {
          const [dd, mm, yyyy] = item.date.split('/')
          const itemDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`)
          return itemDate >= start && itemDate <= end
        })
      }
    }

    const total = filteredMovement.length
    const start = page * size
    const end = start + size
    const paginatedData = filteredMovement.slice(start, end)
    return {
      data: paginatedData,
      total,
    }
  }

  async getOperationTypeList(currentView: string): Promise<{ data: operationType[] }> {
    let operationTypeList = operationTypeMovementData.data
    const excludedIds =
      currentView === 'transfersAndPayments'
        ? [5, 6, 7, 8]
        : currentView === 'contributionsAndRescues'
          ? [1, 2, 3, 4, 7, 8]
          : [1, 2, 3, 4, 5, 6]
    const filteredList = operationTypeList.filter((item) => !excludedIds.includes(item.id))

    return { data: filteredList }
  }

  async getOperationStatusList(): Promise<{ data: operationStatus[] }> {
    const operationStatusList = operationStatusMovementData.data
    return { data: operationStatusList }
  }

  async getLastMovement(
    clientId: number,
    page = 0,
    size = 10,
    type: number,
  ): Promise<{ data: lastMovement[]; total: number }> {
    const lastMovementList = myLastMovement.data.filter(
      (item) =>
        item.clientId === clientId &&
        (type === 3 || item.listType === type)
    )

    const total = lastMovementList.length
    const start = page * size
    const end = start + size
    const paginatedData = lastMovementList.slice(start, end)

    return {
      data: paginatedData,
      total,
    }
  }

}
